import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import type { ThunkDispatchType } from "src/app/reducers/IMainAppState";
import {
  GatherAccessInfo,
  SetAuthenticationToken,
} from "src/authentication/actions/AuthenticationActionCreator";
import { useAuthenticationTokenCookie } from "src/authentication/hooks/useAuthenticationTokenCookie";
import { useUsernameCookie } from "src/authentication/hooks/useUsernameCookie";
import { AuthenticationToken } from "src/authentication/objects/AuthenticationToken";

export const useAuthenticationTokenResult = () => {
  const dispatch = useDispatch<ThunkDispatchType>();
  const {
    get: getAuthenticationTokenCookie,
    remove: removeAuthenticationTokenCookie,
    renew: renewAuthenticationTokenCookie,
  } = useAuthenticationTokenCookie();
  const { remove: deleteUsernameCookie, renew: renewUsernameCookie } =
    useUsernameCookie();
  return useQuery(
    "authenticationToken",
    async () => {
      try {
        const authenticationTokenCookie = getAuthenticationTokenCookie();
        if (!authenticationTokenCookie) {
          return null;
        }

        const authenticationToken = new AuthenticationToken(
          JSON.parse(authenticationTokenCookie),
        );
        await dispatch(GatherAccessInfo(authenticationToken));
        dispatch(SetAuthenticationToken(authenticationToken));

        // renew
        renewAuthenticationTokenCookie();
        renewUsernameCookie();

        return authenticationToken;
      } catch {
        return null;
      }
    },
    {
      staleTime: Infinity,
      onSuccess: (authenticationToken) => {
        if (!authenticationToken) {
          removeAuthenticationTokenCookie();
          deleteUsernameCookie();
        }
      },
    },
  );
};
